import axios from 'axios';
import { jwtDecode } from 'jwt-decode';  // FIXED: Named import (no default in v4+)

const API_BASE = import.meta.env.VITE_APP_API_URL || '/api';  // From .env

const api = axios.create({ baseURL: API_BASE, headers: { 'Content-Type': 'application/json' } });

// Interceptors: Add JWT, handle 401
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Helpers
export const login = async (email, password) => {
  const { data } = await api.post('/account/login', { email, password });
  if (data.status === 'success') {
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('user', JSON.stringify(data.user));
  }
  return data;
};

export const logout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  window.location.href = '/login';
};

export const getBookings = async (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  const { data } = await api.get(`/bookings${params ? `?${params}` : ''}`);
  return data;
};

export const getSpaces = async () => {
  const { data } = await api.get('/spaces');
  return data;
};

// Add createBooking, updateBooking, etc., as needed
export const createBooking = async (bookingData) => {
  const { data } = await api.post('/bookings', bookingData);
  return data;
};

// NEW: Export 'fetcher' as the instance (fixes Berry's menu.js import)
export const fetcher = api;

export default api;